import { useDispatch, useSelector } from "react-redux";
import { selectCurrentLang, selectTranslations } from "../../services/i18n/i18nSlice";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { setLoading, setNavbarHide, setNavbarHideMobile } from "../../services/global/globalSlice";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

import { EP, proctoringSession } from "../../utils/proctoring";

import Accordion from 'react-bootstrap/Accordion';

import arrow_img from '../../assets/images/arrow-back.svg'
import correct_img from '../../assets/images/questions/correct.svg'
import missing_img from '../../assets/images/questions/missing.svg'
import wrong_img from '../../assets/images/questions/wrong.svg'
import ofa_img from '../../assets/images/ofa/question.svg'
import structure_img from './assets/images/structure.svg'
import point_img from './assets/images/score.svg'
import score_img from './assets/images/scoring.svg'
import pc_img from '../../assets/images/exams/computer-pc.svg'
import thumb_img from '../../assets/images/exams/thumb.svg'

import duration_img from '../../assets/images/exams/timer.svg'
import modules_img from '../../assets/images/exams/modules.svg'
import questions_img from '../../assets/images/exams/questions.svg'
import threshold_img from '../../assets/images/exams/score.svg'
import alert_img from '../../assets/images/exams/warning-alert.svg'
import proctoring_img from '../../assets/images/exams/proctoring.svg'
import degree_img from '../../assets/images/exams/degree.svg'
import repeat_img from '../../assets/images/exams/repeat.svg'
import self_assessment_test_img from '../../assets/images/exams/self_assessment_test.svg'


import { TitleH1 } from "../../components/TitleH1";
import { Text } from "../../components/Text";
import { Button } from "../../components/Button";
import { fetchGetExam, fetchInitExamProctoring, fetchStartExam } from "./ExamsApi";
import { formatScore, buildTopicsMap, renderTopicGroupLabel } from "./examUtils";
import { showError } from "../../features/Error/errorSlice";
import {resetProctoringSession, selectCurrentProctoringSessionActive, setCurrentExam, setProctoringSessionActive } from "../../features/Exam/examSlice";
import ConfirmModal from "../../components/_modals/ConfirmModal";
import { selectAppInfo, selectAppPersonalizations } from "../../services/utils/appInfoSlice";
import { enterFullscreen } from "../../utils/deviceManagement";
import ProctoringModal from "./_components/ProctoringModal";
import { TitleH2 } from "../../components/TitleH2";
import { isMobile } from "react-device-detect";
import { selectUserInfo } from "../../features/User/userSlice";
import { BASE_URL, WEB_PATH } from "../../config/constants";
import { toast } from "react-toastify";

export default function ExamPreviewScreen(){

    const [examData, setExamData] = useState(null)
    const [topicsMap, setTopicsMap] = useState({})
    const [examStarted, setExamStarted] = useState(false)
    const [examCompleted, setExamCompleted] = useState(false)
    const t = useSelector(selectTranslations)
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const appInfo = useSelector(selectAppInfo)

    const proctoringSessionActive = useSelector(selectCurrentProctoringSessionActive)
    const [showProctoringModal, setShowProctoringModal] = useState(false)
    const personalizations = useSelector(selectAppPersonalizations)
    const userInfo = useSelector(selectUserInfo)

    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: "",
        icon: ofa_img
    })

    const {exam_id} = useParams()

    const renderTotalTime = () => {
        let total = 0
        examData?.modules?.forEach((m, i)=> {
            total += m.time + (i > 0 ? (m.time_between_modules ?? 5) : 0)
        });
        return total
    }
    
    const closeConfirmModal = () => {
        setConfirmModal({
            ...confirmModal,
            show: false
        })
    }

    const initProctoringSession = async (_,forceStart = false) => {
        if(forceStart){
            setShowProctoringModal(false)
            dispatch(setLoading(true))
            const check_started = await fetchGetExam({exam_id:exam_id})
            if(
                (!check_started.success && 
                    (check_started.error === "User exam not started" || check_started.error === "User exam not found")) 
                ||  (check_started?.success && !check_started?.data?.start_date )){
                const response = await fetchInitExamProctoring({exam_id: examData?.exam_id || exam_id})
                if(response.success){
                    dispatch(setCurrentExam({
                        exam_id: exam_id,
                        user_exam_id: response.data.user_exam_id
                    }))
                    setExamData({
                        ...examData,
                        user_exam_id: response.data.user_exam_id
                    })
                    // PROCTORING START
                    EP.launch(response?.data?.proctoring_guid,
                        (session) => {
                            console.log("✅ Proctoring attivo", session)
                            dispatch(setProctoringSessionActive({session_active: true}))
                        },
                        (error) => {
                            console.error("❌ Errore Proctoring", error);
                            dispatch(showError({
                                title: t.exam.errors.proctoring,
                                text: t.exam.errors.start_text,
                                redirect: "/exams"
                            }));
                        }
                    );
                } else {
                    dispatch(showError({
                        title: t.proctoring.errors.start,
                        text: t.proctoring.errors.start_text,
                        redirect: "/exams",
                        cta_text: t.exam.errors.go_back
                    }))
                }
            } else {
                const response = await fetchInitExamProctoring({exam_id: examData?.exam_id || exam_id})
                if(response.success){
                    dispatch(setCurrentExam({
                        exam_id: exam_id,
                        user_exam_id: response.data.user_exam_id
                    }))
                    setExamData({
                        ...examData,
                        user_exam_id: response.data.user_exam_id
                    })
                    // PROCTORING START
                    EP.launch(response?.data?.proctoring_guid,
                        (session) => {
                            console.log("✅ Proctoring attivo", session)
                            dispatch(setProctoringSessionActive({session_active: true}))
                        },
                        (error) => {
                            console.error("❌ Errore Proctoring", error);
                            dispatch(showError({
                                title: t.exam.errors.proctoring,
                                text: t.exam.errors.start_text,
                                redirect: "/exams"
                            }));
                        }
                    );
                } else {
                    dispatch(showError({
                        title: t.proctoring.errors.start,
                        text: t.proctoring.errors.start_text,
                        redirect: "/exams",
                        cta_text: t.exam.errors.go_back
                    }))
                }
            }
            dispatch(setLoading(false))
        } else { 
            setShowProctoringModal(true)        
        }
    }

    // start_exam resumes the exact attempt it is given, so a user_exam_id may only be sent
    // for an attempt that is still open (e.g. the one created by the proctoring init):
    // handing it an already ended attempt makes it return that old attempt instead of
    // opening a new one, which breaks every repeatable exam after the first attempt
    const resumableUserExamId = (check_started) => (
        check_started?.success && check_started?.data?.user_exam_id && !check_started?.data?.end_date
            ? check_started.data.user_exam_id
            : null
    )

    const startLinearExam = async (_,forceStart = false) => {
        if(examStarted) {
            if(examData?.proctoring_required && proctoringSessionActive){
                if(proctoringSession?.isWindowOpen()){
                    console.log('starto-procotr');
                    proctoringSession.start()
                } else{
                    dispatch(showError({
                        title: t.proctoring.proctoring_not_found,
                        text: t.proctoring.proctoring_not_found_text,
                        cta_text: t.exam.errors.go_back
                    }))
                    setConfirmModal({
                        ...confirmModal,
                        show: false
                    })
                    dispatch(resetProctoringSession())
                    dispatch(setLoading(false))
                    return;
                }
            }
            dispatch(setLoading(true))
            dispatch(setCurrentExam({exam_id: exam_id, user_exam_id: examData?.user_exam_id }))
            if(examData?.proctoring_required && proctoringSessionActive){
                enterFullscreen()
            }
            navigate('/exams/perform/',{replace:true, state:examData})
        } else {
            if ((appInfo.is_ofa || examData?.proctoring_required || examData?.is_not_resumable || examData?.is_self_assessment_test) && !forceStart){
                setConfirmModal({
                    ...confirmModal,
                    title: examData?.is_self_assessment_test ? t.exam.start_alert_title : t.ofa.exam.start,
                    text: examData?.is_self_assessment_test ? t.exam.start_alert_text : t.ofa.exam.start_text,
                    confirmCta: t.ofa.exam.start_button,
                    onConfirm: () => startLinearExam(true,true),
                    onClose: () => {closeConfirmModal()},
                    show: true
                })
            } else {
                dispatch(setLoading(true))
                const check_started = await fetchGetExam({exam_id:exam_id})
                const shouldStartNewAttempt = (!check_started.success &&
                    (check_started.error === "User exam not started" || check_started.error === "User exam not found"))
                    || (check_started?.success && !check_started?.data?.start_date)
                    || (check_started?.success && check_started?.data?.start_date && check_started?.data?.end_date && check_started?.data?.exam?.is_multiple_attempts)
                if(shouldStartNewAttempt){
                    if(examData?.proctoring_required && proctoringSessionActive){
                        if(proctoringSession?.isWindowOpen()){
                            console.log('starto-procotr');
                            proctoringSession.start()
                        } else{
                            dispatch(showError({
                                title: t.proctoring.proctoring_not_found,
                                text: t.proctoring.proctoring_not_found_text,
                                cta_text: t.exam.errors.go_back
                            }))
                            setConfirmModal({
                                ...confirmModal,
                                show: false
                            })
                            dispatch(resetProctoringSession())
                            dispatch(setLoading(false))
                            return;
                        }
                    }
                    const open_user_exam_id = resumableUserExamId(check_started)
                    const response = await fetchStartExam({
                        exam_id: examData?.exam_id || exam_id,
                        ...(open_user_exam_id && {user_exam_id: open_user_exam_id})
                    })
                    if(response.success){
                        dispatch(setCurrentExam({exam_id: exam_id}))
                        if(examData?.proctoring_required && proctoringSessionActive){
                            enterFullscreen()
                        }
                        navigate('/exams/perform/',{replace:true, state:response.data})
                    } else {
                        dispatch(showError({
                            title: t.exam.errors.start,
                            text: t.exam.errors.start_text,
                            redirect: "/exams",
                            cta_text: t.exam.errors.go_back
                        }))
                    }
                } else {
                    dispatch(setLoading(true))
                    dispatch(setCurrentExam({exam_id: exam_id}))
                    navigate('/exams/perform/',{replace:true, state:examData})
                }
                
            }
            
        }
        
    }

    const startModuleExam = async () => {
        dispatch(setLoading(true))
        if(examStarted) {
            dispatch(setCurrentExam({exam_id: exam_id, user_exam_id: examData?.user_exam_id }))
            if(examData?.proctoring_required && proctoringSessionActive){
                enterFullscreen()
            }
            navigate('/exams/perform/',{replace:true, state:examData})
        } else {
            const check_started = await fetchGetExam({exam_id:exam_id})
            const shouldStartNewAttempt = (!check_started.success &&
                (check_started.error === "User exam not started" || check_started.error === "User exam not found"))
                || (check_started?.success && !check_started?.data?.start_date)
                || (check_started?.success && check_started?.data?.start_date && check_started?.data?.end_date && check_started?.data?.exam?.is_multiple_attempts)
            if(shouldStartNewAttempt){
                if(examData?.proctoring_required && proctoringSessionActive){
                    if(proctoringSession?.isWindowOpen()){
                        proctoringSession.start()
                    } else {
                        dispatch(showError({
                            title: t.proctoring.proctoring_not_found,
                            text: t.proctoring.proctoring_not_found_text,
                            cta_text: t.exam.errors.go_back
                        }))
                        setConfirmModal({
                            ...confirmModal,
                            show: false
                        })
                        dispatch(resetProctoringSession())
                        dispatch(setLoading(false))
                        return;
                    }
                }
                const open_user_exam_id = resumableUserExamId(check_started)
                const response = await fetchStartExam({
                    exam_id: examData?.exam_id || exam_id,
                    ...(open_user_exam_id && {user_exam_id: open_user_exam_id})
                })
                if(response.success){
                    dispatch(setCurrentExam({exam_id: exam_id}))
                    if(examData?.proctoring_required && proctoringSessionActive){
                        enterFullscreen()
                    }
                    navigate('/exams/start_module/',{replace:true, state:response.data})
                } else {
                    dispatch(showError({
                        title: t.exam.errors.start,
                        text: t.exam.errors.start_text,
                        redirect: "/exams",
                        cta_text: t.exam.errors.go_back
                    }))
                }
            } else {
                dispatch(setCurrentExam({exam_id: exam_id}))
                navigate('/exams/perform/',{replace:true, state:examData})
            }
        }
    }

    const canCustomizeStructure = !examStarted && !examCompleted
        && examData?.is_customizable && examData?.modules?.some(m => m.topics?.length > 0)

    // once an attempt exists, show what was actually assigned to this user rather than
    // the exam template's own counts, which can disagree with a customized selection
    const displayedQuestionsCount = examData?.resumed_user_modules
        ? examData.resumed_user_modules.reduce((sum, m) => sum + (m.questions?.length || 0), 0)
        : examData?.questions_count
    const displayedModulesCount = examData?.resumed_user_modules?.length ?? examData?.modules_count

    const goToCustomizeExam = () => {
        // no user_exam_id on purpose: customization always starts a fresh attempt,
        // never resumes a stale/ended one
        navigate(`/exams/customize/${examData?.exam_id || exam_id}`)
    }

    const loadExamData = async (exam_id) => {
        const response = await fetchGetExam({exam_id:exam_id, user_exam_id: examData?.user_exam_id})
        if(response.success){
            let _examData = response.data?.exam
            setExamData({
                ..._examData,
                user_exam_start_date: response?.data?.start_date,
                user_exam_end_date: response?.data?.end_date,
                user_exam_id: response?.data?.user_exam_id,
                admin_exam_resume_authorized: response?.data?.admin_exam_resume_authorized,
                bypass_proctoring: response?.data?.bypass_proctoring,
                // exam.questions_count/modules_count describe the template, not this
                // specific attempt: once a user_exam exists, get_exam also returns the
                // actual per-user modules (already resolved to the real drawn questions),
                // which is what the "Struttura" summary below should reflect on resume
                resumed_user_modules: response?.data?.user_modules
            })
            setTopicsMap(buildTopicsMap(response.data?.subjects))
            setExamStarted(
                response.data?.start_date && response.data?.end_date && response.data?.exam?.is_multiple_attempts
                    ? false
                    : !!(response.data?.start_date && !response.data?.end_date)
            )
            setExamCompleted(
                !!(response.data?.start_date && response.data?.end_date && !response.data?.exam?.is_multiple_attempts)
            )
            dispatch(setLoading(false))
        } else {
            dispatch(showError({
                title: t.exam.errors.start,
                text: t.exam.errors.start_text,
                redirect: "/exams",
                cta_text: t.exam.errors.go_back
            }))
        }
    }
    const normalizeUrl = (url) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return `${window.location.protocol}//${url}`
        }
        return url
    }

    const getRedirectUrl = () => {
        if(personalizations?.tenant_settings?.url_webapp){
            return personalizations.tenant_settings.url_webapp
        } else {
            return `${window.location.origin}` 
        }
    }


    const copyUrl = () => {
        const url = new URL(`${normalizeUrl(getRedirectUrl())}${WEB_PATH}/login/`);
        navigator.clipboard.writeText(url);
        toast.success("Indirizzo copiato")
    }

    useEffect(()=>{
        dispatch(setLoading(true))
        if(location.state?.exam)
            // always go through loadExamData: it's the same /get_exam call checkExamStart used to
            // make and throw away, but its response is the only one with topic_names/subjects attached
            // (attach_topic_names/process_exam_subjects run server-side regardless of start state),
            // which the topic breakdown below needs to actually render topic names
            loadExamData(location.state?.exam?.exam_id)
        else
            navigate('/exams',{replace:true})
        dispatch(setLoading(false))
        // eslint-disable-next-line
    },[location])

    useEffect(()=>{
        dispatch(setNavbarHide(true))
        dispatch(setNavbarHideMobile(true))
        // eslint-disable-next-line
    },[examData?.exam_id, exam_id])

    return (
        <section id="examPreviewScreen">
            <div className='section_header d-flex justify-content-between align-items-center'>
                <Link to={'/exams'}><img src={arrow_img} className='pointer' alt=""/></Link>
                <Link to={'/account/contact'}>{t.account.need_help}</Link>
            </div>
            {examData ?
            <>
            {
                examData?.proctoring_required && isMobile ?
                <>
                    <div className="px-3 pt-5 mt-5 h-100 d-flex justify-content-start align-items-center flex-column text-center ">
                        <img src={pc_img} style={{width:'60px'}}/>
                        <TitleH1 className="mt-2">{t.self_assessment_test.pc_login}</TitleH1>
                        <p>Vai su <strong style={{color:'var(--primary-color)'}}><i><u>{`${getRedirectUrl()}${WEB_PATH}`}</u></i></strong> e accedi con l’e-mail che hai confermato, la trovi qui sotto.</p>
                        <div className="bottom_controller">
                            <p>{t.self_assessment_test.login_with} <strong style={{color:'var(--primary-color)'}}>{userInfo?.user_data?.email}</strong></p>
                            <Button className="w-100 mx-auto" onClick={copyUrl}>
                                {t.self_assessment_test.copy_link}
                            </Button>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="pt-4 pt-lg-1">
                        {
                            examData?.proctoring_required && proctoringSessionActive  ?
                            <div className="preview_success mb-3 text-center">
                                <img src={correct_img} />
                                <TitleH2 className="mb-0 mt-2">{t.proctoring.active}</TitleH2>
                            </div> : null
                        }
                        <TitleH1 className="text-center">{examData?.title}</TitleH1>
                        <Text className="text-center">{examData?.description}</Text>
                        {
                            canCustomizeStructure &&
                            <div className="preview_disclaimer mt-2 text-center">
                                <Text className="mb-0">{t.exam.customizable_notice}</Text>
                            </div>
                        }
                        {
                            (examData?.is_not_resumable && !examData?.admin_exam_resume_authorized) 
                            && (examData?.user_exam_start_date && !examData?.user_exam_end_date) 
                            && examStarted ?
                                <div className="preview_alert mt-4 text-center">
                                    <img src={alert_img} />
                                    <Text className="mb-0 mt-2">{t.exam.exam_not_resumable}</Text>
                                    <Link to={'/account/contact'}><Button className="mx-auto mt-2">{t.account.contact}</Button></Link>
                                </div> : null
                        }
                        {
                            examData?.admin_exam_resume_authorized && examStarted ?
                            <div className="preview_disclaimer mt-4 text-center">
                                <Text className="mb-0 mt-2">{t.exam.resume_available_text}</Text>
                            </div> : null
                        }

                        <Accordion defaultActiveKey={appInfo.is_ofa ? 'ofa' : '0'} style={{maxWidth:'600px'}} className="mx-auto">
                            
                            {
                                !canCustomizeStructure &&
                                <Accordion.Item eventKey="0" >
                                    <Accordion.Header><img src={structure_img} alt="" className="me-2"/> {t.exam.structure}</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <Text className="mb-0"><img src={duration_img} /> {t.exam.duration}</Text>
                                            <span><strong>{examData.time ? examData.time : renderTotalTime()} min</strong></span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <Text className="mb-0"><img src={questions_img} /> {t.exam.questions}</Text>
                                            <span><strong>{displayedQuestionsCount}</strong></span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <Text className="mb-0"  ><img src={modules_img} /> {t.exam.modules}</Text>
                                            <span><strong>{displayedModulesCount}</strong></span>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            }
                            {
                                canCustomizeStructure &&
                                examData?.modules?.map((m, i) => (
                                    <Accordion.Item eventKey={`module-${i}`} key={i}>
                                        <Accordion.Header><img src={modules_img} alt="" className="me-2"/> {m.module_name}</Accordion.Header>
                                        <Accordion.Body>
                                            {
                                                m.topics && m.topics.length > 0 ?
                                                m.topics.map((topic, j) => (
                                                    <Text className="mb-1" key={j}>{renderTopicGroupLabel(topic, topicsMap)}</Text>
                                                ))
                                                :
                                                <Text className="mb-0">{t.exam.customize.fixed_module_notice}</Text>
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))
                            }
                            {
                                (appInfo.is_ofa || examData?.is_self_assessment_test) &&
                                <Accordion.Item eventKey="ofa" >
                                    <Accordion.Header><img src={point_img} alt="" className="me-2"/>
                                        {examData?.is_self_assessment_test ? 
                                            t.ofa.exam.ofa_minimum_score :
                                        t.ofa.exam.score}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        {
                                            examData?.modules?.find( m => m.thresholds?.length > 0) ?
                                            <>
                                                {examData?.modules?.map((m,i)=>{
                                                    return(
                                                        <div className="mb-2 d-flex justify-content-between align-items-center" key={i}>
                                                            <span>{m.module_name}</span>
                                                            <span>{t.ofa.scoring.at_least} <img src={correct_img} /> {formatScore(m?.thresholds[0]?.score)} {t.ofa.scoring.correct} </span>
                                                        </div>
                                                    )}
                                                    )
                                                }
                                            </> : 
                                            null
                                        }
                                        {
                                            examData?.thresholds?.find( t => t.score > 0 && t.threshold_type === "certificate_generation") ?  
                                            <div className="d-flex justify-content-between align-items-center">
                                                <Text className="mb-0">{examData?.thresholds?.find( t => t.score > 0 && t.threshold_type === "certificate_generation")?.threshold_name}</Text>
                                                <span><strong>{formatScore(examData?.thresholds?.find( t => t.score > 0 && t.threshold_type === "certificate_generation")?.score)} punti</strong></span>
                                            </div> : 
                                            null
                                        }
                                    </Accordion.Body>
                                </Accordion.Item>
                            }
                        <Accordion.Item eventKey="1">
                            <Accordion.Header><img src={score_img} alt="" className="me-2"/>{t.exam.scoring}</Accordion.Header>
                            <Accordion.Body>
                                {examData?.modules?.map((m,i)=>{
                                    return(
                                        <div className="mb-2    " key={i}>
                                            <span>{m.module_name}</span>
                                            <div className="d-flex justify-content-around">
                                                <div><img src={correct_img}  alt="" /><strong>{formatScore(m.correct_answer_score)}</strong> pt</div>
                                                <div><img src={missing_img}  alt="" /><strong>{formatScore(m.omitted_answer_score)}</strong> pt</div>
                                                <div><img src={wrong_img}  alt="" /><strong>{formatScore(m.wrong_answer_score)}</strong> pt</div>
                                            </div>
                                        </div> 
                                    )
                                })}
                            
                            </Accordion.Body>
                        </Accordion.Item>
                        </Accordion>
                        {
                            examData?.preview_disclaimer &&
                            <div className="preview_disclaimer mt-4 text-center">
                                <Text className="mb-0">{examData?.preview_disclaimer}</Text>
                            </div>
                        }

                        {
                            (   examData?.is_self_assessment_test || 
                                examData?.is_multiple_attempts ||
                                examData?.proctoring_required || 
                                examData?.thresholds?.find(t => t.threshold_type === "certificate_generation")) &&
                                <div className="row justify-content-between align-items-center mx-auto mt-4 mb-4" style={{maxWidth:'600px'}}>
                                    {
                                        examData?.is_self_assessment_test &&
                                        <div className="col text-center exam_preview_card">
                                            <img src={self_assessment_test_img} alt=""/>
                                            <p className="mb-0">{t.exam.self_assessment_test}</p> 
                                        </div>
                                    }
                                    {
                                        examData?.proctoring_required &&
                                        <div className="col text-center exam_preview_card">
                                            <img src={proctoring_img} alt=""/>
                                            <p className="mb-0">{t.exam.proctoring_required}</p> 
                                        </div>
                                    }
                                    {
                                        examData?.thresholds?.find(t => t.threshold_type === "certificate_generation") &&
                                        <div className="col text-center exam_preview_card">
                                            <img src={degree_img} alt=""/>
                                            <p className="mb-0">{t.exam.official_cerficate}</p> 
                                        </div>
                                    }
                                    {
                                        examData?.is_multiple_attempts &&
                                        <div className="col text-center exam_preview_card">
                                            <img src={repeat_img} alt=""/>
                                            <p className="mb-0">{t.exam.is_multiple_attempts}</p> 
                                        </div>
                                    }
                                </div>
                        }
                    </div>
                    {
                        examData?.start_date && new Date(examData?.start_date) <= new Date() ?
                            <div className="mb-3 pb-5">

                                { userInfo?.user_data?.compensational_measures?.calculator_enabled || 
                                    userInfo?.user_data?.compensational_measures?.additional_time_percentage ?
                                    <div className="preview_info my-3 text-center">
                                        <img src={thumb_img} />
                                        <Text className="mb-0 mt-2">{t.exam.additional_measures_added}</Text>
                                    </div> : <div className="text-center">
                                        {
                                            appInfo?.personalizations?.tenant_settings?.is_ofa || appInfo?.personalizations?.tenant_settings?.is_self_assessment ?
                                                <p>{t.exam.request_additional_measure} <Link to={'/account/contact'}>{t.account.contact}</Link></p> :
                                                ''
                                        }
                                    </div>
                                }

                                {
                                    examCompleted ?
                                        <div className="preview_alert mt-4 text-center">
                                            <img src={alert_img} />
                                            <Text className="mb-0 mt-2">{t.exam.exam_already_completed}</Text>
                                        </div>
                                    : (examData?.is_not_resumable && !examData?.admin_exam_resume_authorized) && examStarted ?
                                        null
                                    :
                                    <>
                                    {
                                        (examData?.proctoring_required && !examData?.bypass_proctoring) && !proctoringSessionActive ?
                                        <>
                                            <Button className="mx-auto" onClick={initProctoringSession}>{t.proctoring.start_proctoring}</Button>
                                        </> :
                                        <>
                                            {
                                                canCustomizeStructure ?
                                                // a customizable exam's real question count/duration only exist after
                                                // customization, so the primary action goes straight there instead of
                                                // starting with default counts the student never chose
                                                <Button className="mx-auto" onClick={goToCustomizeExam}>{t.exam.customize_structure}</Button>
                                            : examData?.time ?
                                                <Button className="mx-auto" onClick={startLinearExam}>{examStarted? t.exam.continue_exam :  t.exam.start_exam}</Button>
                                            :
                                                <Button className="mx-auto" onClick={startModuleExam}>{examStarted? t.exam.continue_exam : t.exam.start_firts_module}</Button>
                                            }
                                        </>
                                    }
                                    </>
                                }
                                
                                
                            </div>
                        :
                            <span style={{fontSize:"12px",fontWeight:"500",color:"#6D6F73"}} className="text-center">{t.exams.available_from} {new Date(examData?.start_date).toLocaleDateString()}</span>
                    }
                    <ConfirmModal props={confirmModal}/>
                    <ProctoringModal show={showProctoringModal} handleConfirm={initProctoringSession}  handleClose={() => setShowProctoringModal(false)}/>
                    </>
                }
            </>
            : null}
        </section>
    )
}